// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1vvw9","doubleRow":"Form_doubleRow__3qSEg","campi":"Form_campi__9SjaT","p":"Form_p__3o8k1","submitBox":"Form_submitBox__2FZAN"};